<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('nav.tv_codes_list_title') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading" class="mb-3" variant="primary" :to="{ name: 'TvCodeCreate' }">
                {{ $t('tv_code.create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card bg-variant="light" :header="$dt('tv_code.info.title', 'How to use TV codes')">
              {{ $dt('tv_code.info.body', `
              Tv codes are used to easily authenticate a session for a specific page.
              A code can be used on the /tv page to authenticate a session for a specific page.
              Once a code is used, it cannot be used again (indicated by is_used field).
              `) }}
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
              <b-form-select :options="[2, 10, 20, 50, 100, 500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary" />
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length" />
              <b-table v-else class="table-sm text-center" responsive bordered :no-local-sorting=true
                :sort-by.sync="filters.sort_field" :sort-desc.sync="filters.sort_order" :fields="tableFields"
                :items="tableItems">
                <template v-slot:cell(tv_code_tags)="row">
                  <template v-if="row.item.tv_code_tags">
                    <b-badge v-for="tag in row.item.tv_code_tags" :key="tag.id" class="mx-1">{{ tag.tag.name }}</b-badge>
                  </template>
                </template>
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                    <router-link v-if="true" :to="{ name: 'TvCodeUpdate', params: { id: row.item.id } }">
                      <a><i class="mx-1 fa fa-edit fa-lg" /></a>
                    </router-link>
                    <Delete v-if="true" :id="row.item.id" @deleted="getData" :deleteFn="() => deleteFn(row.item.id)" />
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator at bottom-->
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import { mapActions } from 'vuex';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      tableFields: [
        { key: 'id', sortable: true, label: this.$t('global.id') },
        { key: 'code', sortable: true, label: this.$t('tv_code.code') },
        { key: 'is_used', sortable: true, label: this.$t('tv_code.is_used') },
        { key: 'url', sortable: true, label: this.$t('global.url') },
        { key: 'user_id', sortable: true, label: this.$t('global.user_id') },
        { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        // { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView, Delete
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    ...mapActions('Auth', [VT.LOAD_USER_INFO]),
    getData() {
      this.loading = true;
      Services.tv_codes.list(this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });

      this[VT.LOAD_USER_INFO]().then(() => { });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'TvCodes', params: { page } });
    },
    deleteFn(id) {
      return Services.tv_codes.delete(id);
    }
  }
};
</script>

<style scoped></style>
